import { persistCombineReducers, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import expireIn from 'redux-persist-transform-expire-in';
import { CookieStorage } from 'redux-persist-cookie-storage';
import Cookies from 'cookies-js';
import main from './ducks/legacy/MainDuck';
import authorization from './ducks/legacy/AuthorizationDuck';
import order from './ducks/legacy/OrderDuck';
import profile from './ducks/legacy/ProfileDuck';
import restaurants from './ducks/legacy/RestaurantsDuck';
import stripe from './ducks/legacy/StripeDuck';
import time from './ducks/new/Time/TimeReducer';
import restaurant from './ducks/new/Restaurant/RestaurantReducer';
import address from './ducks/new/Address/AddressReducer';
import seo from './ducks/new/Seo/SeoReducer';
import gift from './ducks/legacy/GiftDuck';
import reorder from './ducks/legacy/ReorderDuck';

const safeDeserialize = (serial) => {
  if (serial == null || serial === 'undefined' || serial === '') {
    return undefined;
  }
  try {
    return JSON.parse(serial);
  } catch (e) {
    return undefined;
  }
};

const logoutActionName = 'authorization/logoutResponse';

// https://github.com/sirLisko/redux-persist-transform-expire-in
const expirationDelay = 1 * 60 * 60 * 1000; // expire in 60 minutes
const expirationKey = 'expirationKey';
const appVersion = process.env?.REACT_APP_VERSION ?? '0.0.0';

const persistConfig = {
  key: `rootstore_${appVersion}`,
  storage,
  transforms: [expireIn(expirationDelay, expirationKey, [])],
  blacklist: ['profile', 'main', 'restaurants'],
  deserialize: safeDeserialize,
};

const mainPersistConfig = {
  key: `mainStore_${appVersion}`,
  storage,
  blacklist: ['globalLoaderQueue'],
  deserialize: safeDeserialize,
};

const profilePersistConfig = {
  key: `profileStore_${appVersion}`,
  storage,
  blacklist: ['getAddressesResponse', 'resetPasswordResponse'],
  deserialize: safeDeserialize,
};

const restaurantsPersistConfig = {
  key: `restaurantsStore_${appVersion}`,
  storage,
  whitelist: ['selectedRestaurant'],
  deserialize: safeDeserialize,
};

const authPersistConfig = {
  key: `authStore_${appVersion}`,
  storage: new CookieStorage(Cookies),
  stateReconciler(inboundState, originalState) {
    return originalState;
  },
  blacklist: ['addresses'],
  deserialize: safeDeserialize,
};

const timePersistConfig = {
  key: `timeStore_${appVersion}`,
  storage,
  transforms: [expireIn(expirationDelay, 'timeExpirationKey', [])],
  blacklist: [],
  deserialize: safeDeserialize,
};

const restaurantNewPersistConfig = {
  key: `restaurantNewStore_${appVersion}`,
  storage,
  blacklist: [],
  deserialize: safeDeserialize,
};

const addressPersistConfig = {
  key: `addressStore_${appVersion}`,
  storage,
  blacklist: [],
  deserialize: safeDeserialize,
};

const seoPersistConfig = {
  key: `seoStore_${appVersion}`,
  storage,
  blacklist: [],
  deserialize: safeDeserialize,
};

const reducers = {
  // legacy
  order,
  stripe,
  gift,
  reorder,
  restaurants: persistReducer(restaurantsPersistConfig, restaurants),
  authorization: persistReducer(authPersistConfig, authorization),
  main: persistReducer(mainPersistConfig, main),
  profile: persistReducer(profilePersistConfig, profile),
  // new
  time: persistReducer(timePersistConfig, time),
  restaurant: persistReducer(restaurantNewPersistConfig, restaurant),
  address: persistReducer(addressPersistConfig, address),
  seo: persistReducer(seoPersistConfig, seo),
};

export const rootReducer = persistCombineReducers(persistConfig, reducers);

const appReducer = (state, action) => {
  if (action.type === logoutActionName) {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

export default appReducer;
